import _ from 'lodash';
import api from '../../api';

let emptyConversation = {
	messages: [],
	users: [],
};

const state = {
	instance: null,
	instance_saving: false,
	instance_saved: false,
	conversation: emptyConversation,
	fetching: false,
};

const actions = {

	load: function (context, payload) 
	{
		const params = payload;
		const promise = api.message.show(params);
		context.commit('handleConversationLoading', true);
		promise.then((response) => {
			context.commit('handleConversationLoaded', response.data);
		})
		.catch((error) => {
			// ...
		})
		.then(() => {
			context.commit('handleConversationLoading', false);
		});
	},

	store: function (context, payload) 
	{
		const uuid = payload;
		const instance_params = context.state.instance;
		const promise = api.message.store(instance_params);
		context.commit('handleStatus', { instance_saving: true });
		promise
			.then((response) => {
				context.commit('handleSent');
				context.commit('handleStatus', { instance_saved: true });
				context.commit('handleResetInstance', {});
			})
			.catch((error) => {
				context.commit('handleFailed');
				context.commit('handleStatus', { instance_saved: false	});
			})
			.then(() => {
				context.commit('handleStatus', { instance_saving: false });
			}); 
	},

	updateInstance: function (context, payload)
	{
		context.commit('handleUpdateInstance', payload);
	},

	resetInstance: function (context, payload)
	{
		context.commit('handleResetInstance', null);
	},	
};


const mutations = {

	handleUpdateInstance: function (state, payload) 
	{
		_.each(payload, (value,key) => {
			if (value == null) {
				_.unset(state, `instance.${key}`);	
			} else {
				_.set(state, `instance.${key}`, value);	
			}
		});
	},

	handleResetInstance: function (state, payload) 
	{
		_.set(state, 'instance', {});
	},

	handleStatus: function (state, payload) 
	{
		_.each(payload, (value, key) => {
			_.set(state, key, value);
		});
	},

	handleConversationLoading: function(state, status) {
		state.fetching = status;
		if (status == true) {
			state.conversation = emptyConversation
		}
	},

	handleConversationLoaded: function(state, payload) {
		state.conversation = payload
	},


	handleSent: function(state)
	{
		// do nothing...
	},

	handleFailed: function(state)
	{
		// do nothing...
	},
};

const getters = {

}


export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}